import { forwardRef, useImperativeHandle, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Img from '../Img';
import styles from './style.module.css';

const AlertBox = forwardRef((props, ref) => {
  const [property, setProperty] = useState({});
  const [alert, setAlert] = useState(false);
  const { t } = useTranslation();

  //  The component instance will be extended
  useImperativeHandle(ref, () => ({
    showAlert(config, value = true) {
      if (!config) return;
      setAlert(value);
      setProperty(config);
    }
  }));

  const linkClickHandler = (e) => {
    e.preventDefault();
    props.onClickLink();
  };
  return (
    <>
      {alert && (
        <div className={styles.alert_container}>
          <div className={styles.alert_icon}>
            <Img
              src={`/${property.icon}.svg`}
              alt={property.status}
              width="45"
              height="45"
              className={styles.icon}
            />
          </div>
          <div className={styles.alert_content}>
            <h1 className={styles.alert_title}>{t(property.title)}</h1>

            <p className={styles.text}>
              {property?.link && (
                <a href="javascript.void(0)" onClick={linkClickHandler}>
                  {t(property.link)}
                </a>
              )}
              {t(property.text, { email: props.email})}
            </p>
          </div>
          <div className={styles.close_icon}>
            <Img
              src="/ic-close.svg"
              alt="ic-close"
              width="14"
              height="14"
              onClick={() => setAlert(false)}
            />
          </div>
        </div>
      )}
    </>
  );
});

export default AlertBox;
